var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#DECCFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.983 18.81C16.1325 18.3135 17.3872 17.8792 16.4175 16.0485C13.4685 10.4782 15.636 7.5 18.7507 7.5C21.927 7.5 24.0413 10.593 21.0833 16.0485C20.0843 17.8897 21.411 18.324 23.5148 18.81C25.377 19.2405 25.5 20.1502 25.5 21.7267V22.5H12C12 20.4412 11.835 19.3065 13.983 18.81ZM4.5 22.5H10.3568C10.3305 16.3673 12.9338 18.5153 12.9338 14.1547C12.9338 12.2715 11.7045 11.25 10.1228 11.25C7.7865 11.25 6.16125 13.4842 8.373 17.6617C9.09975 19.0343 7.59975 19.3605 5.98725 19.7325C4.59075 20.055 4.5 20.7375 4.5 21.9202V22.5Z",
    fill: "#6E39CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.10d144441c6be60eb5d99fbc85b383fc.svg";
export { ForwardRef as ReactComponent };